import React from 'react'

import { Skeleton } from 'antd'

import { FillingSteps } from './components/FillingSteps'
import { useCustomFields } from './hooks/useCustomFields'
import { CustomFieldSingle } from './components/CustomFieldSingle'
import { CustomFieldGroup } from './components/CustomFieldGroup'
import { PanelHeader } from './components/PanelHeader'

import './styles.less'

export function CustomFields(props) {
  const {
    formValues,
    visibleGroups,
    customFields,
    isLoading,
    onChangeValue,
    actionName,
    setGroupVisible,
    setGroupHidden,
    visibleFields,
    isReadOnly,
    isPreview
  } = useCustomFields(props)

  const { errors } = props

  function hasFieldErrors(fields) {
    return fields.some(({ internalFieldName }) => internalFieldName in errors)
  }

  const renderPanelHeader = (groupName, fields) => <PanelHeader groupName={groupName} fields={fields} />

  if (isLoading) {
    return (
      <div className="CustomFieldsComponent__skeleton">
        <Skeleton active />
        <Skeleton active />
      </div>
    )
  }

  if (!customFields) return null

  return (
    <div className="CustomFieldsComponent">
      <hr />
      <FillingSteps actionName={actionName} fieldGroups={visibleFields} formValues={formValues} />

      {Object.keys(visibleGroups).length > 0 &&
        Array.from(customFields.entries()).map(([fieldName, { isGroup, isGroupUnderGroup, groupType, fields }]) => {
          if (!isGroup) {
            const field = fields[0]
            return (
              <CustomFieldSingle
                key={fieldName}
                field={field}
                fields={fields}
                onChangeValue={onChangeValue}
                errors={errors}
                value={formValues[field.internalFieldName]}
                isReadOnly={isReadOnly}
                isPreview={isPreview}
              />
            )
          }
          return (
            <CustomFieldGroup
              key={fieldName}
              fieldName={fieldName}
              fields={fields}
              hasFieldErrors={hasFieldErrors}
              renderPanelHeader={renderPanelHeader}
              formValues={formValues}
              onChangeValue={onChangeValue}
              errors={errors}
              isReadOnly={isReadOnly}
              isPreview={isPreview}
              visibleGroups={visibleGroups}
              groupType={groupType}
              setGroupVisible={setGroupVisible}
              setGroupHidden={setGroupHidden}
              isGroupUnderGroup={isGroupUnderGroup}
            />
          )
        })}
    </div>
  )
}
